/**
 * eventfive.core-v2
 * 
 * @license Copyright (c) eventfive GmbH
 * 
 */

import * as e5 from "./core.esm.js";

//@ts-ignore
window.e5 = e5;